import { render, staticRenderFns } from "./MonetizedStores.vue?vue&type=template&id=cab062ec&"
import script from "./MonetizedStores.vue?vue&type=script&lang=js&"
export * from "./MonetizedStores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports